/**
 * Adaptive Points Plugin for uPlot
 * Shows points when toggle is enabled
 */

import uPlot from "uplot";

export function adaptivePointsPlugin(
  showPointsRef: { current: boolean },
  enabledRef: { current: boolean }
) {
  let lastShowPoints: boolean | null = null;

  return {
    hooks: {
      ready: [
        (_u: uPlot) => {
          // Show points only when enabled
          const shouldShowPoints = enabledRef.current;
          lastShowPoints = shouldShowPoints;
          showPointsRef.current = shouldShowPoints;
        },
      ],
      setScale: [
        (u: uPlot, scaleKey: string) => {
          if (scaleKey !== "x") return;

          // Show points only when enabled
          const shouldShowPoints = enabledRef.current;

          if (shouldShowPoints !== lastShowPoints) {
            lastShowPoints = shouldShowPoints;
            showPointsRef.current = shouldShowPoints;
            u.redraw();
          }
        },
      ],
    },
  };
}
